// extracted by mini-css-extract-plugin
export var colorSquare = "_qn-0";
export var danger = "_qn-5";
export var lightPink = "_qn-8";
export var neutralBlue = "_qn-7";
export var neutralYellow = "_qn-6";
export var normal = "_qn-1";
export var primary = "_qn-2";
export var primaryLight = "_qn-3";
export var solidBlack = "_qn-g";
export var solidGreen = "_qn-b";
export var solidLightBlue = "_qn-d";
export var solidNavy = "_qn-c";
export var solidOrange = "_qn-f";
export var solidPink = "_qn-e";
export var solidRed = "_qn-9";
export var solidYellow = "_qn-a";
export var success = "_qn-4";